import type { UploadFile, UploadProps } from "antd";

export const localUploadCustomRequest: UploadProps["customRequest"] = ({
  onSuccess,
}) => {
  setTimeout(() => onSuccess?.("ok"), 0);
};

export const localUploadBaseProps: Pick<UploadProps, "name" | "customRequest"> =
  {
    name: "file",
    customRequest: localUploadCustomRequest,
  };

export const getLocalUploadPreviewUrl = (
  file: UploadFile
): string | undefined => {
  if (file.url) return file.url;
  if (file.thumbUrl) return file.thumbUrl;
  if (file.originFileObj) {
    return URL.createObjectURL(file.originFileObj as Blob);
  }
  return undefined;
};
